<template>
  <div class="tab-contacts">
    <v-list class="pa-0">
      <template v-for="(item, index) in filteredItems">
        <v-list-tile
          :key="item.name + index"
          avatar
          ripple
          :class="selected(item)"
          @click="onContactClicked(item)"
          @contextmenu="showMenu(item.contactId)"
        >
          <drag :transferData="item" @dragstart="handleDragStart()" @dragend="handleDragEnd()">
            <template slot="image">
              <v-list-tile-avatar>
                <user-avatar 
                  :avatar="item.avatar"
                  :username="item.name" 
                  :size="80"
                />
              </v-list-tile-avatar>
            </template>
            <v-layout align-center row fill-height>

              <v-list-tile-avatar>
                <user-avatar 
                  :avatar="item.avatar"
                  :username="item.name" 
                  :size="40"
                />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="getTitle(item)"></v-list-tile-title>
              </v-list-tile-content>
            </v-layout>
          </drag>
        </v-list-tile>

        <v-divider
          v-if="index + 1 < filteredItems.length"
          :inset="true"
          :key="'d' + index"
        />

      </template>
    </v-list>

    <v-menu 
      v-model="menuVisible"
      :position-x="x"
      :position-y="y"
      bottom
      offset-y
    >
      <v-list>
        <v-list-tile
          v-for="(item, index) in menuItems"
          :key="'menu' + index"
          @click="menuItemClicked(item.key)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

  </div>
</template>

<style>
  .tab-contacts .v-list__tile {
    height: 57px !important; /* same as chat height */
    padding: 6px 16px;
  }
</style>

<script>
  import UserAvatar from '@common/UserAvatar.vue'
  import { EventBus } from '@/event-bus'

  const ContextMenuId = {
    context_menu_contact_details: 0,
    context_menu_remove_contact: 1,
    context_menu_block: 2,
    context_menu_clear_history: 3
  }

  export default {
    name: 'tab-contacts',
    components: { 
      UserAvatar 
    },
    data () {
      return {
        visible: false,
        contacts: [],
        blockedContacts: [],
        contextMenuData: [],
        contextMenuContactId: -1,
        menuVisible: false,
        menuItems: [
          { key: ContextMenuId.context_menu_contact_details, title: this.$t('contacts_contact_details') },
          { key: ContextMenuId.context_menu_remove_contact, title: this.$t('contacts_delete_contact') },
          { key: ContextMenuId.context_menu_block, title: this.$t('contacts_block') },
          { key: ContextMenuId.context_menu_clear_history, title: this.$t('chat_menu_clear_history') }
        ],
        x: 0,
        y: 0,
      }
    },
    props: {
      filter: {
        type: String, 
        default: ''
      },
    },
    computed: {
      filteredItems() {
        let result
        if (this.filter !== '') {
          const filter = new RegExp(this.filter, 'i')
          result = this.contacts.filter(it => it.name.match(filter))
        } else {
          result = this.contacts
        }
        return result
      }
    },
    mounted() { 
      this.fetchContacts()
      this.fetchBlockedContacts()
    },
    methods: {
      fetchContacts() {
        this.$store.dispatch('fetchContacts').then((resp) => {
          this.contacts = resp
          //console.log('-- fetch contacts: ' + JSON.stringify(resp))
        })
      },
      fetchBlockedContacts() {
        this.$store.dispatch('fetchBlockedContacts').then((resp) => {
          this.blockedContacts = resp
          console.log('-- fetch blocked contacts: ' + JSON.stringify(resp))
        })
      },
      onContactClicked(item) {
        this.$store.dispatch('openSingleChat', item).then((resp) => {
          // TODO: ?
        })
      },
      selected(item) {
        return (item.chatId === this.$store.state.currentChat.chatId) ? 'selection' : ''
      },    
      isBlocked(item) {      
        return this.isBlockedId(item.contactId)
      },
      isBlockedId(contactId) {      
        return this.blockedContacts.includes(contactId)
      },
      showMenu (contactId) {
        if (this.contextMenuContactId != -1)
          this.closeContextMenu()
        this.contextMenuContactId = contactId
        this.setBlockUnblockMenu(this.isBlockedId(contactId), contactId)
        event.preventDefault()
        this.x = event.clientX
        this.y = event.clientY
        this.$nextTick(() => this.menuVisible = true)
      },
      setBlockUnblockMenu(blocked, contactId) {
        let title = blocked? this.$t('contacts_unblock') : this.$t('contacts_block')
        this.$set(this.menuItems, 2, { title: title, key: ContextMenuId.context_menu_block }) 
      },
      menuItemClicked(key) {
        this.closeContextMenu()

        switch (key) {
          case ContextMenuId.context_menu_contact_details:
            this.contactDetails(this.contextMenuContactId)
            break
          case ContextMenuId.context_menu_remove_contact:
            this.removeContact(this.contextMenuContactId)
            break
          case ContextMenuId.context_menu_block:
            if(this.isBlockedId(this.contextMenuContactId))
              this.unblockContact(this.contextMenuContactId)
            else
              this.blockContact(this.contextMenuContactId)
            break
          case ContextMenuId.context_menu_clear_history:
            this.clearHistory(this.contacts.filter(it => it.contactId = this.contextMenuContactId))
            break
          default:
            throw new Error('-- unknown key: ' + key)
        }
      },
      contactDetails (contactId) {
        EventBus.$emit('open-contact-profile', contactId)
      },
      removeContact(contactId) {
        this.$store.dispatch('removeContact', contactId).then(() => {
          this.fetchContacts()
        })
      },
      blockContact(contactId) {
        this.$store.dispatch('blockContact', contactId).then((s) => {
          this.blockedContacts.push(contactId)
        })
      },
      unblockContact(contactId) {
        this.$store.dispatch('unblockContact', contactId).then((s) => {
          this.blockedContacts = this.blockedContacts.filter(e => e !== contactId)
        })
      },
      clearHistory(item) {
        this.$store.dispatch('clearHistory', Number(item.chatId))
      },
      handleDragStart() {
         let dragover = document.getElementById("dragover")
        dragover.style.visibility = "visible";
      },
      handleDragEnd() {
        let dragover = document.getElementById("dragover")    
        dragover.style.visibility = "hidden";
      },
      closeContextMenu() {
        this.menuVisible = false
      },
      contactBlocked(id){
        this.blockedContacts.push(id)
      },
      contactUnblocked(id) {
        let index = this.blockedContacts.indexOf(id);
        if (index !== -1) this.blockedContacts.splice(index, 1);
      },
      getTitle(item) {
        return this.safeTextWithEmoji(item.name)
      }
    },
    watch: {
      // TODO:
      visible: function(newValue, oldValue) {
        //console.log(`-- ${newValue}`);
        this.contacts = this.$store.getters.getContacts()
      }
    }
  }
</script>